import DatabaseModel from './DatabaseModel.js';

var Cualificaciones = Object.create(DatabaseModel);

Cualificaciones.model = 'cualificaciones';
Cualificaciones.modelFront = 'cualificaciones';

export default Cualificaciones;
